import React from 'react';
import { Link } from 'gatsby';
import {
  Image,
} from '../common';
import { getPriceRange } from '../../util/helpers';
import './ProductListItem.scss';

const ProductListItem = (props) => {
  const {
    shopSlug,
    handle,
    title,
    images,
    variants,
  } = props;
  return (
    <div className="product-list-item">
      <Link
        className="container"
        to={`/${shopSlug}/${handle}/`}
        aria-label={`See more about ${title}`}
      >
        <div className="text-container">
          <div className="image-container">
            <Image image={images[0]} />
            {images.length > 1 && (
              <Image className="hover-image" image={images[1]} />
            )}
          </div>
          <h2 className="title">{title}</h2>
          <span className="price-tag">{getPriceRange(variants)}</span>
        </div>
      </Link>
    </div>
  );
};

export default ProductListItem;
